<div class="">
  <nav class="navbar navbar-expand-lg navbar-light bg-light my-3">
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#mailNav"
      aria-controls="mailNav"
      aria-expanded="false"
      aria-label="mailNav navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse d-flex p-justify-end align-items-end" id="mailNav">
      <form class="form-inline my-2 my-lg-0">
        <button
          class="btn p-0 mr-2 my-sm-0"
          (click)="onBack()"
          type="button"
        >
          <i aria-hidden="true"  title="Back" class="fa fa-chevron-circle-left mr-2"></i>
        </button>
        <button
        class="btn p-0 mr-2 my-sm-0"
          (click)="onReplyChange('forward')"
          type="button"
        >
          <i aria-hidden="true" title="Forward" class="fa fa-rotate-right mr-2"></i>
        </button>
        <button
           class="btn p-0 mr-2 my-sm-0"
          (click)="onReplyChange('replyAll')"
          type="button"
        >
          <i aria-hidden="true" title="Reply All" class="fa fa-reply-all mr-2"></i>
        </button>
        <button
          class="btn p-0 mr-2 my-sm-0"
          (click)="onReplyChange('reply')"
          type="button"
        >
          <i aria-hidden="true" title="Reply" class="fa fa-reply mr-2"></i>
        </button>
        <button
          class="btn p-0 mr-2 my-sm-0"
          (click)="deleteEmail(emailDetails[0]?.id)"
          type="button"
        >
          <i aria-hidden="true" title="Delete" class="fa fa-trash mr-2"></i>
        </button>
      </form>
    </div>
  </nav>
  <div *ngIf="emailDetails">
    <div class="row m-0">
      <div class="col-12 p-0">
        <h3>{{ emailDetails[0]?.subject }}</h3>
      </div>
    </div>
    <hr class="detail_hr">
    <div class="row m-0">
      <!-- later decide To or From based on emailType -->
      <div class="col-8 p-0">
        <div *ngIf="emailDetails[0]?.from?.emailAddress?.name && emailType!='Drafts'  else recipients">
          <strong>{{ emailDetails[0]?.from?.emailAddress?.name }}</strong
          >&lt;{{ emailDetails[0]?.from?.emailAddress?.address }}&gt;
        </div>
        <ng-template #recipients> 
          <div *ngIf="selUsername">
            <strong>{{selUsername}}</strong
            >&lt;{{
              selUsername
            }}&gt;
          </div>
        </ng-template>
      </div>
      <div class="col-4">
        <span class="pull-right">          
          {{ emailDetails[0]?.sentDateTime | date:'EEE M/d/yyyy h:mm a'}}
        </span>
      </div>
    </div>
    <div class="row m-0">
      <div class="col-12 p-0 d-flex flex-wrap">
        <ng-container *ngIf="emailDetails[0]?.toRecipients" >
          <span class="toccDiv">To:</span>
          <div class="toccDiv" *ngFor="let toItem of emailDetails[0]?.toRecipients" >
            <strong>{{ toItem.emailAddress?.name }}</strong
            >&lt;{{ toItem.emailAddress?.address }}&gt;
          </div>
        </ng-container>
        <ng-container *ngIf="emailDetails[0]?.ccRecipients.length">
          <span class="toccDiv">CC:</span>
          <div class="toccDiv" *ngFor="let ccitem of emailDetails[0]?.ccRecipients" >
            <strong>{{ ccitem.emailAddress?.name }}</strong
            >&lt;{{ ccitem.emailAddress?.address }}&gt;
          </div>
        </ng-container>
      </div>
    </div>
    <hr class="detail_hr">
    <div class="mt-1" [innerHtml]="emailDetails[0]?.body?.content | keepHtml"></div>
    <div *ngIf="emailDetails[1].value.length">
      {{ emailDetails[1]?.value?.length }} Downloads
    </div>
    <div class="d-flex flex-wrap">
      <div class="downloads" *ngFor="let download of emailDetails[1].value">
        <a (click)="onDownloadClick(download.contentType,download.contentBytes, download.name)">{{
          download.name
        }}</a>
      </div>
    </div>
  </div>
</div>